import { render, staticRenderFns } from "./tagDailog.vue?vue&type=template&id=f4b24222&scoped=true"
import script from "./tagDailog.vue?vue&type=script&lang=js"
export * from "./tagDailog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b24222",
  null
  
)

export default component.exports